import React from "react";
import {
  Box,
  Chip,
  Typography,
  Switch,
  FormControlLabel,
  Paper,
} from "@mui/material";

const GateVisitorsStatusChips = ({
  visitorTypes,
  selectedVisitorTypes,
  onVisitorTypeToggle,
  smartFilterEnabled,
  onToggleSmartFilter,
  // Status filter props (previously unused)
  statuses = [],
  statusCounts = {},
  activeFilters = [],
  onToggle,
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        mb: 3,
        borderRadius: "16px",
        border: "1px solid rgba(47,99,173,0.08)",
        backgroundColor: "rgba(255,255,255,0.96)",
        boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
      }}
    >
      {/* Visitor Type Filters */}
      {visitorTypes?.length > 0 && (
        <>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 700,
              color: "#223142",
              mb: 1.5,
            }}
          >
            Filter by Visitor Type
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 1,
              mb: 2,
            }}
          >
            {visitorTypes.map((type) => {
              const isActive = selectedVisitorTypes.includes(type.TypeID);

              return (
                <Chip
                  key={`type-${type.TypeID}`}
                  label={type.TypeName}
                  onClick={() => onVisitorTypeToggle(type.TypeID)}
                  variant={isActive ? "filled" : "outlined"}
                  sx={{
                    cursor: "pointer",
                    fontWeight: 600,
                    borderRadius: "8px",
                    backgroundColor: isActive ? "#2f63ad" : "transparent",
                    color: isActive ? "#fff" : "#2f63ad",
                    borderColor: "rgba(47,99,173,0.3)",
                    "&:hover": {
                      backgroundColor: isActive
                        ? "#1f4f94"
                        : "rgba(47,99,173,0.06)",
                    },
                  }}
                />
              );
            })}
          </Box>
        </>
      )}

      {/* Status Filters */}
      {statuses?.length > 0 && (
        <>
          <Typography variant="subtitle1" sx={{ fontWeight:700, color:"#223142", mb:1.5, mt: visitorTypes?.length > 0 ? 2 : 0 }}>
            Filter by Status
          </Typography>
          <Box sx={{ display:"flex", flexWrap:"wrap", gap:1, mb:2 }}>
            {statuses.map((s) => {
              const isActive = activeFilters.includes(s.StatusName);
              const count = statusCounts[s.StatusName] || 0;
              return (
                <Chip key={s.StatusID}
                  label={`${s.StatusName}${count > 0 ? ` (${count})` : ""}`}
                  onClick={() => onToggle?.(s.StatusName)}
                  variant={isActive ? "filled" : "outlined"}
                  sx={{
                    cursor:"pointer", fontWeight:600, borderRadius:"8px",
                    backgroundColor: isActive ? "#0f766e" : "transparent",
                    color: isActive ? "#fff" : "#0f766e",
                    borderColor:"rgba(15,118,110,0.3)",
                    "&:hover":{ backgroundColor: isActive ? "#0d6660" : "rgba(15,118,110,0.06)" },
                  }}
                />
              );
            })}
          </Box>
        </>
      )}

      {/* Smart Filter */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderTop: "1px solid rgba(47,99,173,0.08)",
          pt: 2,
        }}
      >
        <Typography
          variant="body1"
          sx={{
            fontWeight: 600,
            color: "#223142",
          }}
        >
          Smart Filter
        </Typography>

        <FormControlLabel
          control={
            <Switch
              checked={smartFilterEnabled}
              onChange={onToggleSmartFilter}
              color="primary"
            />
          }
          label=""
        />
      </Box>
    </Paper>
  );
};

export default GateVisitorsStatusChips;